"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AppMenu;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const components_1 = require("@alcumus/components");
const react_router_dom_1 = require("react-router-dom");
const recoil_1 = require("recoil");
const react_i18next_1 = require("react-i18next");
const PrivateRoute_1 = require("../PrivateRoute/PrivateRoute");
const SingleSelectDropdown_1 = __importDefault(require("../shared/SingleSelectDropdown"));
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    title: {
        color: components_1.StyleVariables.colors.text.default,
        paddingRight: theme.spacing(1),
    },
    formControl: {
        minWidth: theme.spacing(30),
    },
}));
function AppMenu({ disabled }) {
    const classes = useStyles();
    const history = (0, react_router_dom_1.useHistory)();
    const [app, setApp] = (0, recoil_1.useRecoilState)(PrivateRoute_1.currentApp);
    const [apps] = (0, recoil_1.useRecoilState)(PrivateRoute_1.userAppsState);
    const { t } = (0, react_i18next_1.useTranslation)('AriaLabels');
    const getMenuItems = () => {
        return apps.map((item) => {
            return { value: item.appId, displayName: item.appDisplayName };
        });
    };
    const handleChange = (event) => {
        localStorage.setItem('application_id', event.target.value);
        localStorage.removeItem('user_external_id');
        setApp(event.target.value);
        history.push('/');
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.Text, { as: "h6", className: classes.title }, "Data from"),
        react_1.default.createElement(SingleSelectDropdown_1.default, { value: app, id: "context-chooser", handleChange: handleChange, formControlClassName: classes.formControl, disabled: disabled, "aria-label": t('contextChooser', { ns: 'AriaLabels' }) }, getMenuItems())));
}
